import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import React from 'react';
import {
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
} from 'reactstrap';

import CircularLoading from '../../Common/CircularLoading/CircularLoading';

class ResetPasswordForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: '',
      confirmPassword: '',
      alertBox: true,
      alertBoxMessage: '',
      validate: {
        newPassword: false,
        confirmPassword: false,
      },
      showPasswordNew: false,
      showPasswordConfirm: false,
    };
  }

  handleOnPaste = (e) => {
    e.preventDefault();
    this.props.setMessage('Please enter your new password manually');
  };

  handleEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.resetPassword();
    }
  };

  handleCloseAlert = () => {
    this.setState({ alertBox: false });
  };

  handleChange = (event) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;
    this.validatePassword(value, name);

    this.setState({
      [name]: value,
    });
  };

  validatePassword = (value, name) => {
    const { validate } = this.state;
    let criteria = 0;

    if (/[a-z]/.test(value)) {
      criteria++;
    }
    if (/[A-Z]/.test(value)) {
      criteria++;
    }
    if (/^[a-zA-Z0-9]*$/.test(value) === false) {
      criteria++;
    }
    if (/\d/.test(value) === true) {
      criteria++;
    }
    if (criteria >= 3 && value.length >= 8) {
      validate[name] = true;
    } else {
      validate[name] = false;
    }
    this.setState({ validate });
  };

  resetPassword = () => {
    const { newPassword, confirmPassword } = this.state;

    if (newPassword === confirmPassword) {
      const token = window.location.hash.split('/').pop();
      this.props.resetPassword(newPassword, confirmPassword, token);
    } else {
      this.props.setMessage('Passwords must coincide');
    }

    this.setState({ alertBox: true });
  };

  componentWillUnmount() {
    this.props.setMessage('');
  }

  render() {
    const { newPassword, confirmPassword } = this.state;
    return (
      <div className="forgot-password-form-container">
        <Row className="alert-container ">
          {this.props.message !== null &&
            this.props.message !== '' &&
            this.props.message !== 'true' && (
              <div
                className={this.state.alertBox ? 'alert' : 'd-none'}
                role="alert"
              >
                <i onClick={this.handleCloseAlert} className="icon-close" />
                <p className="description">{this.props.message}</p>
              </div>
            )}
        </Row>
        <h5 className="see text-center mb-4"> Reset Password</h5>
        <p className="see text-center mb-4">
          Your password has expired and you need to change it.
        </p>
        <h6 className="see text-center mb-4">
          Your new password must have at least 8 characters and 3 of the 4 next
          requirements:
        </h6>
        <ul className="text-left">
          <li>Uppercase alphabetic characters</li>
          <li>Lowercase alphabetic characters</li>
          <li>Numeric digits (0-9)</li>
          <li>Non-alphanumeric special characters such as !, $, # or %</li>
        </ul>

        <Form role="form">
          <FormGroup className="mb-3">
            <InputGroup>
              <Input
                className="form-field"
                placeholder="New Password"
                type={this.state.showPasswordNew ? 'text' : 'password'}
                name="newPassword"
                value={newPassword}
                valid={this.state.validate.emailState}
                invalid={!this.state.validate.emailState}
                onChange={(e) => this.handleChange(e)}
                onKeyPress={this.handleEnter}
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={() =>
                    this.setState({
                      showPasswordNew: !this.state.showPasswordNew,
                    })
                  }
                  style={{ border: '0px' }}
                >
                  {this.state.showPasswordNew ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
          <FormGroup className="mb-3">
            <InputGroup>
              <Input
                id="passwordInputId"
                placeholder="Confirm Password"
                type={this.state.showPasswordConfirm ? 'text' : 'password'}
                name="confirmPassword"
                value={confirmPassword}
                onChange={(e) => this.handleChange(e)}
                onKeyPress={this.handleEnter}
                onPaste={(e) => this.handleOnPaste(e)}
              />
              <InputGroupAddon addonType="append">
                <InputGroupText
                  onClick={() =>
                    this.setState({
                      showPasswordConfirm: !this.state.showPasswordConfirm,
                    })
                  }
                  style={{ border: '0px' }}
                >
                  {this.state.showPasswordConfirm ? (
                    <VisibilityIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </InputGroupText>
              </InputGroupAddon>
            </InputGroup>
          </FormGroup>
          <button
            className="w-100 btn forgot-password-button btn-danger "
            type="button"
            onClick={this.resetPassword}
            disabled={
              !(
                this.state.validate.newPassword &&
                this.state.validate.confirmPassword
              )
            }
          >
            {this.props.isLoading ? (
              <CircularLoading className="loading-gif-waiting" />
            ) : (
              'SAVE MY NEW PASSWORD'
            )}
          </button>
        </Form>
      </div>
    );
  }
}
export default ResetPasswordForm;
